import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import SlimCTA from "@/components/layout/SlimCTA";

/**
 * Page wrapper for every non-home route.
 * Adds Header (sticky), page content, slim closing CTA, and Footer.
 *
 * Pass `showCTA={false}` to hide the closing CTA (e.g., on legal pages).
 */
export default function PageLayout({ children, showCTA = true, testId }) {
  return (
    <main data-testid={testId} className="bg-[#050505] text-white min-h-screen overflow-x-hidden">
      <Header />
      {/* Spacer for the fixed 64px header */}
      <div className="h-16" aria-hidden />
      {children}
      {showCTA && <SlimCTA />}
      <Footer />
    </main>
  );
}
